import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledSearchIcon } from './InputField.styles.js';
import { StyledPrefixWordContainer } from './StartFieldAdornment.styles.js';
import { TYPE } from '../constants/common.js';
function StartFieldAdornment(_ref) {
  let {
    type,
    size,
    prefixWord,
    startAdornment
  } = _ref;
  const renderPrefixWord = () => /*#__PURE__*/React__default.createElement(StyledPrefixWordContainer, null, prefixWord);
  const renderStartAdornment = () => {
    switch (type) {
      case TYPE.SEARCH:
        return /*#__PURE__*/React__default.createElement(StyledSearchIcon, null);
      default:
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, startAdornment);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, prefixWord && renderPrefixWord()), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, renderStartAdornment()));
}
StartFieldAdornment.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPE)),
  size: PropTypes.oneOf(['extraLarge', 'large', 'medium', 'small', 'extraSmall', 'extraSmallSmall']),
  /**
   * Text placed before the children.
   */
  prefixWord: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startAdornment: PropTypes.node
};
StartFieldAdornment.defaultProps = {
  type: TYPE.DEFAULT,
  size: 'extraLarge',
  prefixWord: null,
  startAdornment: null
};
export { StartFieldAdornment as default };